import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { 
  tryToFetchMyAccountInfo, 
  tryToDeleteAccount, 
  // tryToDeleteEnterpriseAccount 
} from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'


class UserSettingsDeleteAccountForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      delete_email: props.user.deleteAccountForm.lastSubmit.delete_email,
      delete_password: props.user.deleteAccountForm.lastSubmit.delete_password,
    }

    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  handleDeleteAccount(e){
    if(window.confirm('Are you sure you want to delete your account?')){
      const { dispatch, user } = this.props;
      // if(user.roles.enterprise){
      //   dispatch(tryToDeleteEnterpriseAccount({
      //     delete_email: this.state.delete_email,
      //     delete_password: this.state.delete_password
      //   }))
      // } else {
        dispatch(tryToDeleteAccount({
          delete_email: this.state.delete_email,
          delete_password: this.state.delete_password
        }))
      // }
    }
    if(e) e.preventDefault();
  }

  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    let formDisabled = !state.delete_password || !state.delete_email;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleDeleteAccount(e); 
        }}>
          <CustomField 
            type="email"
            name="email"
            placeholder="email address"
            label="Email"
            value={state.delete_email}
            onChange={(e) => {this.setState({delete_email: e}); }}
            serverErrors={user.deleteAccountForm.errors.delete_email}
            required={true}
            disabled={user.tryingToDeleteAccount}
          />

          <CustomField 
            type="password"
            name="password"
            placeholder="password"
            label="Password"
            value={state.delete_password}
            onChange={(e) => {this.setState({delete_password: e}); }}
            serverErrors={user.deleteAccountForm.errors.delete_password}
            required={true}
            disabled={user.tryingToDeleteAccount}
          />
          <p>This is final and cannot be undone.</p>
          {
            user.deleteAccountForm.errors &&
            <p className="text-danger text-700">
              {
                user.deleteAccountForm.errors.other
              }
            </p>
          }
          <div className="list-right">
            <Button 
              submit={true}
              size="medium"
              disabled={formDisabled}
              thinking={user.tryingToDeleteAccount}
              failed={user.failedToDeleteAccount}
              color="danger" 
              display={user.roles.enterprise ? "Permanently Delete My Account" : "Permanently Delete My Account and Patterns"}
              onClick={this.handleDeleteAccount}
            />
          </div>
        </form>
      </div>
    )
  }
}



UserSettingsDeleteAccountForm = reduxForm({
  form: 'UserSettingsDeleteAccountForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsDeleteAccountForm)

UserSettingsDeleteAccountForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {};
  
  return {
    user,
    initialValues
  }
})(UserSettingsDeleteAccountForm);

export default UserSettingsDeleteAccountForm;



// WEBPACK FOOTER //
// ./src/components/UserSettingsDeleteAccountForm/UserSettingsDeleteAccountForm.js